import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';
import utils from '../../../common/services/utils';

const renderGradeCell = (row, t) => {
	const { grade, weeklyProgram } = row;
	const startTime = utils.parseTime(weeklyProgram.startTime);
	const endTime = utils.parseTime(weeklyProgram.endTime);
	return (
		<div>
			{weeklyProgram.name || grade.name}
			<br />
			{t(ui.days[weeklyProgram.weekday])}
			<br />
			{`${ui.formatTime(startTime)} - ${ui.formatTime(endTime)}`}
		</div>
	);
}

const renderChildCountCell = (row) => {
	const { childCount } = row;

	return childCount.map(value => {
		return [`${ui.formatDate(value.lessonDate)} - ${value.childCount}`, <br />]
	});
}

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('KindergartenMonthlyReport_KindergartenName'),
			accessor: 'kindergarten',
			sortable: true
		},
		{
			header: t('KindergartenMonthlyReport_Grade'),
			accessor: 'kindergarten',
			sortable: false,
			cell: (kindergarten, row) => renderGradeCell(row, t)
		},
		{
			header: t('KindergartenMonthlyReport_ChildrenCount'),
			accessor: 'kindergarten',
			sortable: false,
			cell: (kindergarten, row) => renderChildCountCell(row)
		},
		{
			header: t('KindergartenMonthlyReport_TotalSumForMonth'),
			accessor: 'total',
			sortable: true
		},
		{
			header: t('KindergartenMonthlyReport_UploadedFile'),
			accessor: 'hasAttachedFile',
			sortable: true,
			cell: (hasAttachedFile) => (ui.formatBoolean(hasAttachedFile))
		},
		{
			header: t('KindergartenMonthlyReport_IsPaid'),
			accessor: 'isPaid',
			sortable: true,
			cell: (isPaid) => (ui.formatBoolean(isPaid))
		},
		{
			header: t('KindergartenMonthlyReport_PaymentDate'),
			accessor: 'paymentDate',
			cell: (paymentDate) => (ui.formatDate(paymentDate)),
			sortable: true
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);